export default __webpack_public_path__ + "static/media/Bea 9781408362365.17204243.jpg";